<template>
    <div>
        <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">

            <div class="table-responsive">
                <form id="move_charts" method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data">
                    <input type="hidden" name="_token" :value="csrf">
                    <label>
                        Queste schede verranno spostate:
                    </label>
                    <div>
                        <label> Select the session
                            <select class="form-control" v-model="selectedSession" name="sessionTo" required>
                                <option v-for="(row) in sessions" :value="row.id">
                                    {{row.name}}
                                </option>
                            </select>
                        </label>
                    </div>
                    <div>
                        <ul style="">
                            <li v-for="(row) in list">
                                <input type="hidden" name="charts[]" :value="row.id">
                                {{row.assessed_personName}} &nbsp; {{row.assessed_personSurname}}
                            </li>
                        </ul>
                    </div>


                    <div class="col-md-3 float-right row">

                        <div>
                            <button id="moveButton" disabled type="submit" @click="moveCharts" class="btn btn-rounded btn-block btn-success"><i class="fa fa-arrow-alt-circle-right" aria-hidden="true"></i>{{__('misc.move') }} </button>
                        </div>
                    </div>

                </form>
            </div>
        </vs-popup>
    </div>
</template>

<script>

  export default {

    data () {
        return {
            value: null,
            editing: true,
            active: false,
            list : [],
            action: "",
            title: "",
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            selectedSession: -1,

        }
    },
    methods: {
        moveCharts(){

        },

        toggle(action, title, list, attributes) {
            console.log(action, list, attributes);
            this.active = true;
            this.action = action;
            this.title = title;
            this.list = list;
            if(list.length){
                $("#moveButton").attr("disabled",false);
            }

        }
    },
    mounted() {

    },
    props: {
        sessions : Array
    }

  }
</script>
